export default ['$rootScope', 'NavigationService', function ($rootScope, NavigationService) {
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        NavigationService.updateHistory(toState, toParams, fromState, fromParams);
    });
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/navigation/NavigationListener.js
// module id = 1918
// module chunks = 0